import React, { useState } from 'react';
import { BottomBar } from '../../../components/BottomBar';
import { FaCar, FaRegFile } from 'react-icons/fa';
import { FaPeopleGroup } from 'react-icons/fa6';

import Transportations from './components/transportations';
import InfoMapLayer from '../../../components/InfoMapLayer';
import Cars from './components/cars';
import EmployeeModal from './components/employees';
import { FaCarSide } from 'react-icons/fa6';
import BottomLayout from '../../../components/BottomLayout/BottomLayout';
import useScreenSize from './hooks/useScreenSize';
import { TextField, Popper, Box } from '@mui/material';
import { useDashboardStore } from './store/store';
const MemoizedBottomBar = React.memo(
  (props) => {
    return <BottomBar {...props} />;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.autoCompleteProps.options ===
        nextProps.autoCompleteProps.options &&
      prevProps.showAutoComplete === nextProps.showAutoComplete
    );
  },
);
MemoizedBottomBar.displayName = 'MemoizedBottomBar';
const Ayd = (props) => {
  const { openTransportationModal, toggleCarsModal, toggleEmployeesModal } =
    useDashboardStore();
  const resetModals = useDashboardStore((store) => store.resetModals);
  const setTrueLiveTab = useDashboardStore((store) => store.setTrueLiveTab);
  const setFalseLiveTab = useDashboardStore((store) => store.setFalseLiveTab);
  const onLiveTab = useDashboardStore((store) => store.onLiveTab);
  const setCenter = useDashboardStore((store) => store.setCenter);
  const resetLayerState = useDashboardStore((store) => store.resetLayerState);
  const {
    typeInfo,
    VehicleInfo,
    LocationInfo,
    CardInfo,
    setInfoBarVisible,
    InfoBarVisible,
    resetInfoState,
    adress,
    adressLoading,
  } = useDashboardStore((store) => store);
  const size = useScreenSize();
  const [isOpenAutoComplete, setIsOpenAutoComplete] = useState(false);

  const bottomBarButtons = [
    {
      icon: FaCarSide,
      text: 'Canlı',
      onClick: () => {
        resetInfoState();
        resetLayerState();
        setTrueLiveTab();
        resetModals();
        console.log('props', props);
        props.connect();
      },
    },
    {
      icon: FaRegFile,
      text: 'Görev Raporları',
      onClick: () => {
        resetInfoState();
        resetLayerState();
        setFalseLiveTab();
        resetModals();
        openTransportationModal();

        props.disconnect();
      },
    },
    {
      icon: FaCar,
      text: 'Araç Raporları',
      onClick: () => {
        resetInfoState();
        resetLayerState();
        setFalseLiveTab();
        resetModals({ carsModal: true });
        toggleCarsModal();
        props.disconnect();
      },
    },
    {
      icon: FaPeopleGroup,

      text: 'Personel Raporları',
      onClick: () => {
        resetInfoState();
        resetLayerState();
        setFalseLiveTab();
        resetModals();
        setFalseLiveTab();
        toggleEmployeesModal();
        props.disconnect();
      },
    },
  ];

  return (
    <>
      <Transportations />
      <Cars />
      <EmployeeModal />
      <div className="absolute z-30 bottom-10 flex w-screen items-center justify-center">
        <BottomLayout>
          <InfoMapLayer
            typeInfo={typeInfo}
            setInfoBarVisible={setInfoBarVisible}
            infoBarVisible={InfoBarVisible}
            adress={adress}
            adressLoading={adressLoading}
            cardInfo={CardInfo}
            locationInfo={LocationInfo}
            vehicleInfo={VehicleInfo}
          />
          <MemoizedBottomBar
            buttons={bottomBarButtons}
            showAutoComplete={onLiveTab}
            autoCompleteProps={{
              isOptionEqualToValue: (option, value) =>
                option?.vehiclePlate === value?.vehiclePlate,
              PopperComponent: (props) => {
                return (
                  <Popper
                    {...props}
                    sx={{ fontSize: '10px' }}
                    placement="top-start"
                  />
                );
              },
              noOptionsText: 'Araç Bulunamadı',
              options: props.vehicles,
              getOptionLabel: (option) => option?.vehiclePlate,
              size: 'small',
              onChange: (e, value) => {
                if (value?.latitude && value?.longitude)
                  setCenter([value?.latitude, value?.longitude]);
              },
              onOpen: () => {
                setIsOpenAutoComplete(true);
              },
              onClose: () => {
                setIsOpenAutoComplete(false);
              },
              renderInput: (params) => (
                <TextField
                  {...params}
                  label={isOpenAutoComplete ? null : 'Araç Arayın'}
                  sx={{
                    '& .MuiFormLabel-root': {
                      fontSize: '12px',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        border: 'none',
                      },
                    },
                    '& .MuiAutocomplete-popupIndicator': {
                      border: 'none',
                    },
                    '& .MuiAutocomplete-clearIndicator': {
                      border: 'none',
                    },
                  }}
                />
              ),
              renderOption: (props, option) => (
                <Box component="li" sx={{ fontSize: '12px' }} {...props}>
                  {option?.vehiclePlate}
                </Box>
              ),
              sx: {
                '& .MuiInputBase-root': {
                  borderRadius: isOpenAutoComplete
                    ? '0px 0px 20px 20px'
                    : '20px',
                  border: null,
                },
                '& .MuiAutocomplete-paper': {
                  borderRadius: '20px 20px 0px 0px',
                  boxShadow: '0px',
                },
              },
              style: {
                width: '200px',
                backgroundColor: '#fff',
                borderRadius: isOpenAutoComplete ? '0px 0px 20px 20px' : '20px',
              },
            }}
          />
        </BottomLayout>
      </div>
    </>
  );
};

export default Ayd;
